<!--
 * @Author: 何浩楠 1213144972@qq.com
 * @Date: 2025-07-16 17:08:59
 * @LastEditors: 邓宇芩 707208431@qq.com
 * @LastEditTime: 2025-12-16 16:40:16
 * @FilePath: /VueQRCode/src/views/Home.vue
 * @Description: Beamco Login Screen
-->
<template>
  <div class="login-container">
    <div class="app-title">Ztor .</div>

    <div class="login-card">
      <div class="form-group">
        <label for="scannerLanguage">{{ localeStrings.languageLabel }}</label>
        <div class="select-wrapper" ref="selectWrapper">
          <img src="@/assets/Icon.svg" alt="" class="select-leading-icon" />
          <div class="custom-select" :class="{ 'is-open': isDropdownOpen }">
            <div class="select-selected" @click="toggleDropdown">
              {{ getSelectedLabel() }}
            </div>
            <div v-if="isDropdownOpen" class="select-options">
              <div
                v-for="option in languageOptions"
                :key="option.value"
                class="select-option"
                :class="{ 'is-selected': formData.scannerLanguage === option.value }"
                @click="selectOption(option.value)"
              >
                {{ option.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="scannerName">{{ localeStrings.scannerNameLabel }}</label>
        <input
          type="text"
          id="scannerName"
          v-model="formData.scannerName"
          :placeholder="localeStrings.scannerNamePlaceholder"
          class="form-input"
          disabled
        />
      </div>

      <div class="form-group" v-if="formData.isHavePassword">
        <label for="password">{{ localeStrings.passwordLabel }}</label>
        <input
          type="password"
          id="password"
          v-model="formData.password"
          :placeholder="localeStrings.passwordPlaceholder"
          class="form-input"
        />
      </div>
      <div class="form-group">
        <button class="login-button" @click="handleLogin">
          <span class="login-button-text">{{ formData.isHavePassword ? localeStrings.loginButton : localeStrings.enterButton }}</span>
        </button>
        <!-- <div class="error-message">{{ error }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import locales from "@/locales";
import { getScannerByKey, loginScanner } from "@/api/orderQrcodeScanner";

export default {
  name: "Home",
  data() {
    return {
      formData: {
        scannerLanguage: "en",
        scannerName: "",
        password: "",
        isHavePassword: false,
      },
      urlKey: "",
      id: "",
      token: "",
      scannerName: "",
      error: "",
      isDropdownOpen: false,
      languageOptions: [
        { value: "en", label: "English" },
        { value: "zh_CN", label: "中文简体" },
        { value: "zh_TW", label: "中文繁體" },
      ],
    };
  },
  computed: {
    isFormValid() {
      return (
        this.formData.scannerLanguage.trim() !== "" &&
        this.formData.password.trim() !== ""
      );
    },
    localeStrings() {
      return locales[this.formData.scannerLanguage] || locales.en;
    },
  },
  created() {
    console.log(this.$route.params);

    const savedLanguage = localStorage.getItem("lang");
    if (savedLanguage && locales[savedLanguage]) {
      this.formData.scannerLanguage = savedLanguage;
    } else {
      localStorage.setItem("lang", this.formData.scannerLanguage);
    }
  },
  mounted() {
    this.urlKey = this.$route.params.urlKey;
    console.log(this.$route.params, this.$route.params.urlKey, "22222");
    this.getScammerInfo();
    // 点击外部关闭下拉框
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    handleClickOutside(event) {
      if (this.$refs.selectWrapper && !this.$refs.selectWrapper.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
    selectOption(value) {
      this.formData.scannerLanguage = value;
      this.isDropdownOpen = false;
    },
    getSelectedLabel() {
      const option = this.languageOptions.find(
        (opt) => opt.value === this.formData.scannerLanguage
      );
      return option ? option.label : "English";
    },
    async getScammerInfo() {
      try {
        const result = await getScannerByKey({
          urlKey: this.urlKey,
        });
        console.log("API调用结果:", result);
        if (result.success && result.data) {
          this.res = result;
          this.formData.scannerName = result.data.scannerName || "";
          this.formData.isHavePassword = result.data.isHavePassword || false;
          this.id = result.data.id || "";
          console.log("Scanner name from API:", this.formData.scannerName);
        } else {
          this.err = result;
          this.formData.scannerName = "";
        }
        return result;
      } catch (error) {
        console.error("API调用失败:", error);
      }
    },
    async handleLogin() {
      // if (!this.isFormValid) {
      //   this.$toast.fail(this.localeStrings.toastFillFields);
      //   return;
      // }
      this.error = "我在测试错误信息";
      console.log(this.formData.password, this.urlKey);
      try {
        const result = await loginScanner({
          key: this.urlKey,
          password: this.formData.password,
        });
        console.log("API调用结果:", result, this.formData.scannerName);
        if (result.success) {
          const lang = this.formData.scannerLanguage;
          localStorage.setItem("lang", lang);
          this.token = result.data?.accessToken || "";
          this.$router.push({
            name: "index",
            query: {
              lang,
              id: result.data?.id || this.id || "",
              token: this.token,
              scannerName: this.formData.scannerName,
            },
          });
        } else {
          this.$toast.fail(result.msg || this.localeStrings.toastLoginFailed);
          this.error = result.msg || this.localeStrings.toastLoginFailed;
        }
        return result;
      } catch (error) {
        console.error("API调用失败:", error);
      }
    },
  },
  watch: {
    "formData.scannerLanguage"(newLang) {
      if (newLang && locales[newLang]) {
        localStorage.setItem("lang", newLang);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  padding: 0 12px 12px 12px;
  min-height: 100vh;
  background: var(--Grey-Darkest, #090a0a);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
}

.app-title {
  margin-top: 115.5px;
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-family: var(--app-font-family);
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -1.44px;
}

.login-card {
  margin-top: 54.5px;
  background-color: #191919;
  border-radius: clamp(0.5rem, 2vw, 1rem);
  width: 100%;
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  justify-content: space-between;
  // align-items: center;
  // display: flex;
  flex-direction: column;
  justify-content: center;
  // padding: clamp(1.75rem, 5vh, 2.75rem) clamp(1.5rem, 6vw, 2.25rem);
  gap: var(--LG, 24px);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.35);
  box-sizing: border-box;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    color: var(--White-Lightest, #f7f9fa);
    /* 普通 14 */
    font-family: var(--app-font-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
    text-align: left;
  }
}

.form-input {
  border-radius: 8px;
  border: 1px solid var(--Grey-Light, #343434);
  background: var(--Grey-Darkest, #090a0a);
  height: 56px;
  padding: 0 16px;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;

  &::placeholder {
    color: #888888;
  }

  &:focus {
    outline: none;
    background-color: #222222;
  }

  &:disabled {
    background: var(--Grey-Base, #292929);
    color: #9e9e9e;
    cursor: not-allowed;
  }
}

.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  outline: none;
}

.select-leading-icon {
  position: absolute;
  left: 16px;
  width: 20px;
  height: 20px;
  object-fit: contain;
  pointer-events: none;
  filter: brightness(1.1);
  z-index: 1;
  transition: filter 0.2s ease;
}

.select-wrapper:hover .select-leading-icon {
  filter: brightness(1.2);
}

.select-wrapper:focus-within .select-leading-icon {
  filter: brightness(1.3);
}

.custom-select {
  position: relative;
  width: 100%;
}

.select-selected {
  border-radius: 8px;
  border: 1px solid var(--Grey-Light, #343434);
  background: var(--Grey-Darkest, #090a0a);
  height: 56px;
  padding: 0 44px 0 52px;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: var(--app-font-family);
  transition: all 0.2s ease;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23B0B0B0' d='M6.707 9.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L12 13.586 6.707 9.293Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;

  &:hover {
    border-color: var(--Grey-Lighter, #6c6c72);
  }
}

.select-wrapper:focus-within .select-selected,
.custom-select.is-open .select-selected {
  border-color: var(--Primary-Pink-500, #f68fa6);
  background-color: #222222;
}

.select-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--Grey-Darkest, #090a0a);
  border: 1px solid var(--Grey-Light, #343434);
  border-radius: 8px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.select-option {
  padding: 12px 16px;
  color: #ffffff;
  font-size: 14px;
  font-family: var(--app-font-family);
  cursor: pointer;
  transition: background-color 0.15s ease;
  line-height: 1.5;

  &:hover {
    background: var(--Grey-Base, #292929);
  }

  &.is-selected {
    background: var(--Grey-Base, #292929);
    color: var(--Primary-Pink-500, #f68fa6);
  }

  &:first-child {
    padding-top: 12px;
  }

  &:last-child {
    padding-bottom: 12px;
  }
}

.login-button {
  border: none;
  border-radius: var(--SM, 8px);
  background: var(--Primary-Pink-500, #f68fa6);
  display: flex;
  padding: var(--SM, 8px) var(--MD, 16px);
  justify-content: center;
  align-items: center;
  align-self: stretch;
  // border: none;
  // height: 48px;
  // color: var(--White-Lightest, #f7f9fa);
  // font-family: "Noto Sans TC";
  // font-size: 16px;
  // font-style: normal;
  // font-weight: 700;
  // line-height: 24px; /* 150% */
  // letter-spacing: -0.32px;
  // cursor: pointer;
  // transition: background-color 0.2s ease, transform 0.2s ease;
  // width: 100%;
  // text-align: center;

  // &:hover {
  //   background-color: #222222;
  // }

  // &:active {
  //   background-color: #252525;
  //   transform: scale(0.99);
  // }

  // &:disabled {
  //   background-color: #3a3a3a;
  //   cursor: not-allowed;
  //   color: #b3b3b3;
  //   transform: none;
  // }
}

.login-button-text {
  display: flex;
  padding: var(--SM, 8px) var(--MD, 16px);
  justify-content: center;
  align-items: center;
  align-self: stretch;
  color: var(--Grey-Dark, #1f1f1f);

  /* 中等 14 */
  font-family: var(--app-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
}
</style>
